"use client";

import React from "react";

/**
 * `Ani Card / Read-only` — the translucent, blurred surface the Figma uses to
 * hold both the task list and the chart.
 */
const AniCard = ({
  children,
  className,
  label,
}: {
  children: React.ReactNode;
  className?: string;
  label?: string;
}) => (
  <div
    data-token={label ?? "Ani Card (Read-only)"}
    data-pad="sm"
    data-inspect-tokens="--ani-card-readonly-background --ani-card-border-radius"
    className={`ani-card ani-tint${className ? ` ${className}` : ""}`}
  >
    {children}
  </div>
);

export default AniCard;
